
import { Component, Prop, Vue } from "nuxt-property-decorator";
import CardCarousel from "~/components/shared/CardCarousel.vue";
import { PelletsDealerCard } from "~/types/Pellets";

@Component({
  components: {
    CardCarousel,
  },
})
export default class PelletsDealerCarousel extends Vue {
  @Prop({ default: () => [] }) private dealers!: any[];

  get cdnPath(): string {
    return process.env.PARTNER_MEDIA_CDN || "";
  }

  get dealerCards(): PelletsDealerCard[] {
    return this.dealers.map((dealer) => ({
      name: dealer.companyName || dealer.shortName,
      description: dealer.shortName || "",
      logoUrl: `${this.cdnPath}/partner/${dealer.profileId}/logo/logo-288.jpg`,
      profileUrl: `/pelletshaendler/${dealer.profileSlug}/${
        dealer.preferences?.slug || ""
      }`,
    }));
  }
}
